export const ECG_DATA_LENGTH = 1000
export const ECG_SAVED_DATA_LENGTH = 125 * 60
